var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.254,
    height: 236.968,
    viewBox: "0 0 122.254 236.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M299.18,120.029s23.473,17.951,30.381-26.238S340.6-9.774,370.985,4.034,355.8,48.223,359.943,67.552s31.36,46.632,44.189-5.521c10.358-42.118-16.858-34.306-22.095-22.095-2.072,4.837-11.043,23.473,24.86,92.522s-9.665,62.141-12.43,42.812-16.573-28.994-19.329-17.951,10.624,39,13.808,51.089c3.45,13.114,4.143,33.137-19.329,28.994s-20.717-16.573-35.9-9.665",
    transform: "translate(-298.876 -1.499)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty3);
export default __webpack_public_path__ + "static/media/empty-3.5d11d5e0063bf073b3f49ab92be7a9d7.svg";
export { ForwardRef as ReactComponent };